import { useMemo } from 'react';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const XFollowTriggerDetails = ({ trigger, triggerType }: Props) => {
  const accountName = useMemo(() => {
    if (trigger.context?.usernameToFollow) {
      return trigger.context.usernameToFollow;
    }

    if (trigger.signature) {
      const match = trigger.signature.match(/^x-follow-(.+)$/);
      return match ? match[1] : '';
    }

    return '';
  }, [trigger.context?.usernameToFollow, trigger.signature]);

  const profileUrl = useMemo(() => {
    if (!accountName) return '';
    return `https://x.com/${accountName}`;
  }, [accountName]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      {accountName && <TriggerExternalLinkDetail label="Account" value={`@${accountName}`} href={profileUrl} />}
    </div>
  );
};
